/*
 * Values here mirrors `$grid-breakpoints` from _variables-bootstrap-custom.scss
 * https://github.com/viddsee/viddsee-api/blob/dbddc2c5049d72fdcb7720aeb0fbb41094e70ec3/app/javascript/stylesheets/include/variables/_variables-bootstrap-custom.scss#L47-L58
 */

export const xs = 0;
export const sm = 544;
export const md = 768;
export const lg = 992;
export const xl = 1480;
